module.exports = __webpack_public_path__ + "static/media/SMS.9fa88ea0.mp4";